import React, { useEffect, useState } from "react";
import { AddApprovalFormat, DeleteApprovalFormat, UpdateApprovalFormat, ViewApprovalFormatFlow } from "./BillingApprovalComponnets";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import { BASE_URL } from "../../../config/axios";
import { handleErrorToast } from "../../CustomFunctions";
import { Office, SearchSmall } from "../../AllSvg";
import usePermission from "../../../config/permissions";





const ApproveformatTable = () => {

    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("sitemanagement_project_sub_company") || 'a2b6154c-5c4a-4bcb-a4ec-b151c5c652b5');
    // const [toggleCompany, setToggleCompany] = useState('a2b6154c-5c4a-4bcb-a4ec-b151c5c652b5');
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [seprationFormats, setSeprationFormats] = useState([]);
    const { SUB_COMPANIES } = usePermission();

    const [searchQuery, setSearchQuery] = useState("");
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };
    const getApprovalFormats = async () => {
        setBuffering(true); //buffering logic // Start Buffering 
        try {
            // const res = await axios.get(`${BASE_URL}/wfm/salaryHeadingbysubcompany/${toggleCompany}/`);
            const res = await axios.get(`${BASE_URL}/siteproject/dynamicapprovalscreate/`);
            // const res = await axios.get(`${BASE_URL}/siteproject/dynamicapprovalsbysubcompany/${toggleCompany}/`);
            setSeprationFormats(res.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getApprovalFormats();
    }, [toggleCompany]);

    return (
        <div className="table-css-white-background">
            <div className="table-heading-flex">
                <div className="repo-heading font-weight500    font-size-heading pl15 mb0">Approval Formats</div>
                <div className="field-cont">
                    {/* <div className="table-searchh dropdown-container field-cont-div">
                        <Office />
                        <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                            <option value="null">Select SubCompany</option>
                            {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                        </select>
                    </div> */}
                    <div title="Search" className="table-searchh" style={{ marginRight: "10px" }}>
                        <div >
                            <SearchSmall />
                            <input
                                placeholder="Search"
                                className="navbar-inputt font-weight400  font-size-text"
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>
                    {(seprationFormats.length < 6 && toggleCompany !== 'null') && <AddApprovalFormat getApprovalFormat={getApprovalFormats} />}

                    {/* <AddApprovalFormat getApprovalFormat={getApprovalFormats} /> */}
                </div>
            </div>
            <table className="table-css">
                <thead>
                    <tr className="custom-table-head-tr">
                        <th className="align-left">Sr. No.</th>
                        <th className="align-center">Company</th>
                        <th className="align-center">Name</th>
                        <th className="align-center">No. of Stages</th>
                        <th className="align-center">View Flow</th>
                        <th className="align-right  ">Action</th>
                    </tr>
                </thead>
                {buffer ? (
                    <div className="spinner-bgdatil"></div>  //buffering logic
                ) : (
                    <tbody>
                        {seprationFormats?.filter((e) =>
                            e.format_for?.toLowerCase()?.includes(searchQuery.toLowerCase())
                        )
                            .map((i, index) => (
                                <React.Fragment key={index}>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="6"></td>
                                    </tr>
                                    <tr className="custom-table-head-td">
                                        <td className="align-left">{index + 1}</td>
                                        <td className="align-center">{i.sub_company_title}</td>
                                        <td className="align-center">{i.format_for}</td>
                                        <td className="align-center">{i.stages?.length} Steps</td>
                                        <td className="align-center width-5vw ">
                                            <ViewApprovalFormatFlow
                                                i={i}
                                            />
                                        </td>
                                        <td className="text-right width-5vw ">
                                            <div className="flex-row justify-end">
                                                <UpdateApprovalFormat i={i} getApprovalFormat={getApprovalFormats} />
                                                <DeleteApprovalFormat
                                                    i={i}
                                                    getApprovalFormat={getApprovalFormats}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))}
                    </tbody>
                )}

            </table>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
};


export { ApproveformatTable }